module.exports = __webpack_public_path__ + "media/images/icons/three-users-539cf6923789b143465c7b5f79caa9e9.svg";